
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {OrderStateInfo} from './OrderStateInfo';
import {FieldModelOrderStateInfo} from './OrderStateInfo';

/**
 * OrderStateInfoNotify struct
 */
class OrderStateInfoNotify {
  /**
   * Initialize struct
   * @param {!Array=} orderStates
   * @constructor
   */
  constructor (orderStates = []) {
    this.OrderStates = orderStates
  }

  /**
   * Copy struct (shallow copy)
   * @this {!OrderStateInfoNotify}
   * @param {!OrderStateInfoNotify} other Other struct
   * @returns {!OrderStateInfoNotify} This struct
   */
  copy (other) {
    if (other.OrderStates != null) {
      this.OrderStates = []
      for (let item of other.OrderStates) {
        if (item != null) {
          let tempItem
          tempItem = OrderStateInfo.fromObject(item)
          this.OrderStates.push(tempItem)
        } else {
          this.OrderStates.push(null)
        }
      }
    } else {
      this.OrderStates = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!OrderStateInfoNotify}
   * @returns {!OrderStateInfoNotify} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new OrderStateInfoNotifyModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new OrderStateInfoNotifyModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!OrderStateInfoNotify}
   * @param {!OrderStateInfoNotify} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof OrderStateInfoNotify)) {
      throw new TypeError('Instance of OrderStateInfoNotify is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!OrderStateInfoNotify}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      OrderStates: ((this.OrderStates != null) ? Array.from(this.OrderStates, item => ((item != null) ? item : null)) : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return OrderStateInfoNotify.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!OrderStateInfoNotify} other Object value
   * @returns {!OrderStateInfoNotify} Created struct
   */
  static fromObject (other) {
    return new OrderStateInfoNotify().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!OrderStateInfoNotify}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return OrderStateInfoNotify.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!OrderStateInfoNotify}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 5151
  }
}

export { OrderStateInfoNotify };

/**
 * Fast Binary Encoding OrderStateInfoNotify field model
 */
class FieldModelOrderStateInfoNotify extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.OrderStates = new fbe.FieldModelVector(new FieldModelOrderStateInfo(buffer, 4 + 4), buffer, 4 + 4)
  }

  /**
   * Get the field size
   * @this {!FieldModelOrderStateInfoNotify}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelOrderStateInfoNotify}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.OrderStates.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelOrderStateInfoNotify}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.OrderStates.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelOrderStateInfoNotify}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelOrderStateInfoNotify.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelOrderStateInfoNotify}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 5151
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelOrderStateInfoNotify}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelOrderStateInfoNotify}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.OrderStates.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderStates.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderStates.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelOrderStateInfoNotify}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelOrderStateInfoNotify}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelOrderStateInfoNotify}
   * @param {!OrderStateInfoNotify} fbeValue Default value, defaults is new OrderStateInfoNotify()
   * @returns {!OrderStateInfoNotify} OrderStateInfoNotify value
   */
  get (fbeValue = new OrderStateInfoNotify()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelOrderStateInfoNotify}
   * @param {!OrderStateInfoNotify} fbeValue OrderStateInfoNotify value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.OrderStates.fbeSize) <= fbeStructSize) {
      this.OrderStates.get(fbeValue.OrderStates)
    } else {
      fbeValue.OrderStates.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderStates.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelOrderStateInfoNotify}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelOrderStateInfoNotify}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelOrderStateInfoNotify}
   * @param {!OrderStateInfoNotify} fbeValue OrderStateInfoNotify value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelOrderStateInfoNotify}
   * @param {OrderStateInfoNotify} fbeValue OrderStateInfoNotify value
   */
  setFields (fbeValue) {
    this.OrderStates.set(fbeValue.OrderStates)
  }
}

export { FieldModelOrderStateInfoNotify };

/**
 * Fast Binary Encoding OrderStateInfoNotify model
 */
class OrderStateInfoNotifyModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelOrderStateInfoNotify(this.buffer, 4)
  }

  /**
   * Get the OrderStateInfoNotify model
   * @this {!OrderStateInfoNotifyModel}
   * @returns {!FieldModelOrderStateInfoNotify} model OrderStateInfoNotify model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!OrderStateInfoNotifyModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!OrderStateInfoNotifyModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return OrderStateInfoNotifyModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!OrderStateInfoNotifyModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelOrderStateInfoNotify.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!OrderStateInfoNotifyModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!OrderStateInfoNotifyModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!OrderStateInfoNotifyModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!OrderStateInfoNotifyModel}
   * @param {!OrderStateInfoNotify} value OrderStateInfoNotify value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!OrderStateInfoNotifyModel}
   * @param {!OrderStateInfoNotify} value OrderStateInfoNotify value, defaults is new OrderStateInfoNotify()
   * @return {!object} Deserialized OrderStateInfoNotify value and its size
   */
  deserialize (value = new OrderStateInfoNotify()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new OrderStateInfoNotify(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new OrderStateInfoNotify(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!OrderStateInfoNotifyModel}
   * @param {!number} prev Previous OrderStateInfoNotify model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { OrderStateInfoNotifyModel };
